import {useEffect, useState} from "react";
import ReactSelect, {components} from "react-select"
import {xfetch, HttpVerbo} from "../../util";
import PropTypes from "prop-types";


function SelectFetch({...props}) {

  const [lista, setLista] = useState([])

  const consultaLista = async () => {
    props.setIsCarregando(true)
    const res = await xfetch(props.url, {}, HttpVerbo.GET)
    let json = await res.json()
    if (props.ids) {
      json = json.filter(d => props.ids.includes(d.id))
    }
    setLista(json)
    props.setIsCarregando(false)
  }

  useEffect(() => {
    consultaLista()
  }, [])

  const NoOptionsMessage = props => {
    return (
        <span content="Custom NoOptionsMessage Component">
          <components.NoOptionsMessage {...props}>Nenhum resultado encontrado</components.NoOptionsMessage>
        </span>
    );
  };
  const Placeholder = props => {
    const place = props.placeholder === "Select..." ? 'Selecione...' : props.children;
    return <components.Placeholder {...props}>{place}</components.Placeholder>;
  };

  const options = lista.map((item, k) => {
    return {key: k ,value: item.id, label: item.nome, selected: item.id === props.valorSelecionado}
  });
  return (
    <ReactSelect
      ref={props.ref}
      styles={{
        menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
        menu: (provided) => ({ ...provided, zIndex: 9999 })
      }}
      onChange={props.handleChange}
      options={options}
      isMulti={false}

      components={{ NoOptionsMessage,Placeholder }}
      {...props} />
  );
}
SelectFetch.propTypes = {
  url: PropTypes.string.isRequired,
  handleChange: PropTypes.any,
  setIsCarregando: PropTypes.any,
  placeholder: PropTypes.string,
  multiplo: PropTypes.bool,
  valorSelecionado: PropTypes.number
  // valorAttr: PropTypes.string,
  // nome: PropTypes.string,
  // funcao: PropTypes.func,
}
SelectFetch.defaultProps = {
  multiplo: false,
  setIsCarregando: false,
  valorSelecionado: -1
}

export {SelectFetch};